"use client";

import type { DocsSearchEntry } from "@/lib/docs/catalog";
import { createContext, useContext, useState } from "react";

function useSearchState() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [site, setSite] = useState("all");
  const [version, setVersion] = useState("persistent");
  const [apiResults, setApiResults] = useState<{
    query: string;
    entries: DocsSearchEntry[];
    error?: boolean;
  }>({ query: "", entries: [] });
  return {
    apiResults,
    setApiResults,
    open,
    setOpen,
    query,
    setQuery,
    site,
    setSite,
    version,
    setVersion,
  };
}

const SearchStateContext = createContext<ReturnType<
  typeof useSearchState
> | null>(null);

/** Above the account runtime: resolving a session must not discard public search. */
export function DocsSearchStateProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const state = useSearchState();
  return (
    <SearchStateContext.Provider value={state}>
      {children}
    </SearchStateContext.Provider>
  );
}

export function useDocsSearchState() {
  const shared = useContext(SearchStateContext);
  const local = useSearchState();
  return shared ?? local;
}
